import React from 'react'
import { View, Text, Pressable, StyleSheet, Image } from 'react-native'
import LeftArrow from 'assets/left_arrow.png'
import RightArrow from 'assets/right_arrow.png'

type Props = {
  nextDisabled?: boolean
  goToNextPage: () => void
  goToPreviousPage: () => void
  currentPage: number
}

const SHOW_CURRENT_PAGE = false

const PaginationControls: React.FC<Props> = props => {
  const { currentPage, goToNextPage, goToPreviousPage, nextDisabled } = props

  const previousEnabled = currentPage > 0
  const nextEnabled = !nextDisabled

  const previousDisabledStyle = !previousEnabled
    ? styles.pageTouchableDisabled
    : undefined

  const nextDisabledStyle = !nextEnabled
    ? styles.pageTouchableDisabled
    : undefined

  let currentPageView = null
  if (SHOW_CURRENT_PAGE) {
    currentPageView = (
      <View style={styles.currentPage}>
        <Text>page {currentPage + 1}</Text>
      </View>
    )
  }

  return (
    <View style={styles.container}>
      <Pressable
        style={[styles.pageTouchable, previousDisabledStyle]}
        disabled={!previousEnabled}
        onPress={goToPreviousPage}
      >
        <Image source={LeftArrow} style={styles.arrow} resizeMode="contain" />
      </Pressable>
      {currentPageView}
      <Pressable
        style={[styles.pageTouchable, nextDisabledStyle]}
        disabled={!nextEnabled}
        onPress={goToNextPage}
      >
        <Image source={RightArrow} style={styles.arrow} resizeMode="contain" />
      </Pressable>
    </View>
  )
}

PaginationControls.defaultProps = {
  nextDisabled: false,
}

const styles = StyleSheet.create({
  container: {
    marginLeft: 'auto',
    marginVertical: 8,
    marginRight: 16,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  pageTouchable: {
    marginLeft: 8,
  },
  pageTouchableDisabled: {
    opacity: 0.2,
  },
  currentPage: {
    fontWeight: 'bold',
    marginVertical: 0,
    marginHorizontal: 10,
  },
  arrow: {
    width: 20,
    height: 20,
  },
})

export default PaginationControls
